// extracted by mini-css-extract-plugin
export default {"livestream-floating__container":"styles_livestream-floating__container__ixeoN","livestream-floating__text-container":"styles_livestream-floating__text-container__+0Q2m"};